import { UpstreamEvent } from 'client';
import React from 'react';
import { FilterDrawer as FilterDrawerComponent } from 'routes/components/filter-drawer';

import { useFilterDrawerMap } from 'DesignSystem/features/table-context/use-table-context';
import { cn } from 'DesignSystem/utils';

export default function FilterDrawer() {
  const filterMap = useFilterDrawerMap<UpstreamEvent>();
  const status = filterMap.get('status');
  const customerStatus = filterMap.get('customer_status');
  const severity = filterMap.get('severity');
  const eventType = filterMap.get('event_type');
  const hasAffectedItems = filterMap.get('has_affected_items');
  const hasImpactedLocations = filterMap.get('has_impacted_locations');
  const announcedDate = filterMap.get('announced_date');
  const lastUpdated = filterMap.get('last_updated');

  return (
    <FilterDrawerComponent method="GET">
      <div className="flex flex-col gap-5">
        <FilterSection className="gap-3">
          {hasAffectedItems && <hasAffectedItems.Component />}
          {hasImpactedLocations && <hasImpactedLocations.Component />}
        </FilterSection>

        <FilterSection>
          <FilterGroup>
            {status && (
              <FilterGroupItem>
                <FilterGroupItemLabel>{status.meta.label}</FilterGroupItemLabel>
                <status.Component />
              </FilterGroupItem>
            )}
            {customerStatus && (
              <FilterGroupItem>
                <FilterGroupItemLabel>{customerStatus.meta.label}</FilterGroupItemLabel>
                <customerStatus.Component />
              </FilterGroupItem>
            )}
            {severity && (
              <FilterGroupItem>
                <FilterGroupItemLabel>{severity.meta.label}</FilterGroupItemLabel>
                <severity.Component />
              </FilterGroupItem>
            )}
            {eventType && (
              <FilterGroupItem>
                <FilterGroupItemLabel>{eventType.meta.label}</FilterGroupItemLabel>
                <eventType.Component />
              </FilterGroupItem>
            )}
            {announcedDate && (
              <FilterGroupItem>
                <FilterGroupItemLabel>{announcedDate.meta.label}</FilterGroupItemLabel>
                <announcedDate.Component />
              </FilterGroupItem>
            )}
            {lastUpdated && (
              <FilterGroupItem>
                <FilterGroupItemLabel>{lastUpdated.meta.label}</FilterGroupItemLabel>
                <lastUpdated.Component />
              </FilterGroupItem>
            )}
          </FilterGroup>
        </FilterSection>
      </div>
    </FilterDrawerComponent>
  );
}

function FilterSection(props: React.ComponentProps<'div'>) {
  return <div {...props} className={cn('flex flex-col gap-2', props.className)} />;
}

function FilterGroup(props: React.ComponentProps<'div'>) {
  return <div {...props} className={cn('flex flex-col gap-5', props.className)}></div>;
}

function FilterGroupItem(props: React.ComponentProps<'div'>) {
  return <div {...props} className={cn('flex flex-col gap-1', props.className)}></div>;
}

function FilterGroupItemLabel(props: React.ComponentProps<'p'>) {
  return <p {...props} className={cn('text-smallMedium', props.className)} />;
}
